import React, { useState } from 'react'
import { FaCloud } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";

import IVRimage from '../../images/ivr-img.png'
import whatsappimage from '../../images/whatsapp-logo.png'
import Voice from '../../images/voice.png'
import CTC from '../../images/ctc (1).png'
import TTc from '../../images/tts (2).png'
import SMS from '../../images/cleaver-tap.png'
import Email from '../../images/manage-alert.png'
import RCS from '../../images/rcs-logo.png'
import URL from '../../images/yrl-shorter.png'
import workflow from '../../images/workflow.png'
import shofify from '../../images/shopify-image.png'
import Zoho from '../../images/quabe.png'
import plably from '../../images/pabbly-image.png'
import fresh from '../../images/lines-munu.png'
import monoge from '../../images/moengage.png'
import gogglesheet from '../../images/google-sheets.png'
import WebEngage from '../../images/product4.png'


function Products() {




    const [channels, setChannels] = useState( [
        {
            id: 1,
            name: "IVR",
            status: "Assigned",
            visibility: "Hide from User",
            image: IVRimage
        },
        {
            id: 2,
            name: "WhatsApp",
            status: "Assigned",
            visibility: "Hide from User",
            image: whatsappimage
        },
        {
            id: 3,
            name: "Voice",
            status: "Unassigned",
            visibility: "Hide from User",
            image: Voice
        },
        {
            id: 4,
            name: "ClickToCall",
            status: "Unassigned",
            visibility: "Hide from User",
            image: CTC
        },
        {
            id: 5,
            name: "TextToSpeech",
            status: "Unassigned",
            visibility: "Hide from User",
            image: TTc
        },
        {
            id: 6,
            name: "SMS",
            status: "Unassigned",
            visibility: "Hide from User",
            image: SMS
        },
        {
            id: 7,
            name: "Email",
            status: "Unassigned",
            visibility: "Hide from User",
            image: Email
        },
        {
            id: 8,
            name: "RCSMessage",
            status: "Unassigned",
            visibility: "Hide from User",
            image: RCS
        },
        {
            id: 9,
            name: "URLShortener",
            status: "Unassigned",
            visibility: "Hide from User",
            image: URL
        },
        {
            id: 10,
            name: "Workflow",
            status: "Unassigned",
            visibility: "Hide from User",
            image: workflow
        },
        {
            id: 11,
            name: "Shopify",
            status: "Unassigned",
            visibility: "Hide from User",
            image: shofify
        },
        {
            id: 12,
            name: "CleaverTap",
            status: "Unassigned",
            visibility: "Hide from User",
            image: SMS
        },
        {
            id: 13,
            name: "Plabbly",
            status: "Unassigned",
            visibility: "Hide from User",
            image: plably
        },
        {
            id: 14,
            name: "ZohoFlow",
            status: "Unassigned",
            visibility: "Hide from User",
            image: Zoho
        },
        {
            id: 15,
            name: "Freshworks",
            status: "Unassigned",
            visibility: "Hide from User",
            image: fresh
        },
        {
            id: 16,
            name: "Moengage",
            status: "Unassigned",
            visibility: "Hide from User",
            image: monoge
        },
        {
            id: 17,
            name: "GoogleSheets",
            status: "Unassigned",
            visibility: "Hide from User",
            image: gogglesheet
        },
        {
            id: 18,
            name: "WebEngage",
            status: "Unassigned",
            visibility: "Hide from User",
            image: WebEngage
        }
    ]);

    const toggleStatus = (id) => {
        setChannels(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        status: item.status === "Assigned" ? "Unassigned" : "Assigned"
                    }
                    : item
            )
        );
    };

    const toggleVisibilty = (id) => {
        setChannels(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, isVisible: !item.isVisible }
                    : item
            )
        );
    };


    return (
        <>
            <div className='border-[1px] border-[#cfcdcd] p-2 w-[100%] rounded-md mt-4'>
                <div className='w-[100%] border-b-[1px] pb-1 border-[#cfcdcd] flex justify-between items-center'>
                    <h2 className='text-[20px] text-[#000] font-semibold'>Product Assignment</h2>
                    <button className='p-2 bg-[#3fca90] rounded-md text-[12px] flex items-center gap-1 font-semibold text-[#fff]'>
                        <FaCloud /> Save Changes
                    </button>
                </div>
                <div className='w-[100%] flex justify-between items-center flex-wrap p-2 gap-y-4'>
                    {channels.map((item) => (
                        <div className='shadow-[rgba(0,0,0,0.24)_0px_3px_8px] p-2  w-[100%] sm:w-[48%] lg:w-[32%] rounded-md flex justify-between items-center pb-4 h-[100px] '>
                            <div>
                                <h5 className='text-[#000] font-semibold text-[14px] flex items-center gap-1'>{item.name}
                                    {item.status == 'Unassigned' ? <IoIosCloseCircle className='text-[#ed5050]' /> : <FaCheckCircle className='text-[#3fca90]' />
                                    }
                                    
                                </h5>
                                <div className='mt-4 flex items-center gap-2'>
                                    <button
                                        onClick={() => toggleStatus(item.id)}
                                        className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${item.status == 'Assigned' ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                                    >
                                        <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${item.status == 'Unassigned' ? "translate-x-[13px]" : ""}`}></div>
                                    </button>
                                    <span
                                        onClick={() => toggleStatus(item.id)}
                                        className='text-[12px] text-[#576071]'>Assigned</span>
                                </div>
                                {item.status == 'Unassigned' &&
                                    <div className='mt-2 flex items-center gap-2'>
                                        <button
                                            onClick={() => toggleVisibilty(item.id)}
                                            className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${item.isVisible ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                                        >
                                            <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${item.isVisible ? "translate-x-[13px]" : ""}`}></div>
                                        </button>

                                        <span className='text-[12px] text-[#576071]'>
                                            {item.visibility}
                                        </span>
                                    </div>
                                }
                            </div>
                            <img src={item.image} alt=""
                                className='w-[50px] h-[40px] sm:w-[60px] sm:h-[50px] object-contain mt-2 sm:mt-0'
                            />
                        </div>
                    ))

                    }
                </div>
            </div>
        </>
    )
}

export default Products
